import { Fragment, FunctionComponent, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from 'react-intl';
import { IPrivacyStatement } from "../util/DataModelInterface";
import { getPrivacyStatement } from "../api/Terms";
import { Spinner } from "../components/Spinner";
import parse from 'html-react-parser';
import useToastHandler from "../hooks/useToastHandler";

export const PrivacyStatement: FunctionComponent = () => {
  const intl = useIntl();
  const lang = intl.locale;
  const { addToast } = useToastHandler();

  const [terms, setTerms] = useState([] as IPrivacyStatement[]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getPrivacyStatement().then((data: any) => {
        //console.log("PrivacyStatement - data", data);
        if (data?.error) {
          addToast(data.error, 'terms', 'fetch');
        } else if (data?.length > 0) {
          data.sort((a: { row_number: number; }, b: { row_number: number; }) => a.row_number - b.row_number);
          setTerms(data);
        }
    }).finally(() => {
      setLoading(false);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getRows = () => {

    return terms.slice(1).map( (row: IPrivacyStatement, index: number) => {
      const header = lang === "fi-FI"
        ? row.header_fi
        : (lang === "en-GB" ? row.header_en : row.header_se);
      let text = lang === "fi-FI"
        ? row.text_fi
        : (lang === "en-GB" ? row.text_en : row.text_se);
      text = text.replaceAll('\\n', '<br/>');
      return (
          <Fragment key={index}>
            <h3 key={index}>
 
                {row.row_number}. {header}
              </h3>
              <p>
                {parse(text)}
       
            </p>
          </Fragment>
      );
    });
  }

  return (
    <>
    <Spinner active={loading} />
    { terms.length > 0 &&
      <div>
 
          <h1><FormattedMessage id='info.privacystatement'/></h1>
          <h2>
            {lang === "fi-FI"
              ? terms[0].header_fi
              : (lang === "en-GB" ? terms[0].header_en : terms[0].header_se)}
        </h2>
        { getRows() }
        <p> <strong> {lang === "fi-FI"
                                ? terms[0].text_fi
                                : (lang === "en-GB" ? terms[0].text_en : terms[0].text_se)}
                              </strong>  </p>

            
    
      </div>
    }
    </>
    );
};